(() => {
  const root = document.documentElement;
  const qs = (selector, scope = document) => scope.querySelector(selector);
  const qsa = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Color swatches (optional visuals JSON keeps the swatch colors in sync with the catalog) */
  const fallbackSwatch = (value = '') => {
    const color = value.toLowerCase();
    if (color.includes('aurora')) return 'linear-gradient(135deg,#143d79 0 42%,#0aac94 42% 100%)';
    if (color.includes('stormlight')) return 'linear-gradient(135deg,#95999d 0 52%,#ffd21d 52% 100%)';
    if (color.includes('blood moon') || color.includes('nightfire')) return 'linear-gradient(135deg,#080808 0 52%,#c20f22 52% 100%)';
    if (color.includes('oxblood')) return '#5a1a1f';
    if (color.includes('baby pink') || color.includes('light pink') || color.includes('soft pink')) return '#efc5cf';
    if (color.includes('rose') || color.includes('pink') || color.includes('bubblegum')) return '#ef5a94';
    if (color.includes('red') || color.includes('fire')) return '#c62727';
    if (color.includes('glacier') || color.includes('frost') || color.includes('ice')) return '#79d6ef';
    if (color.includes('blue')) return '#1769ca';
    if (color.includes('moss') || color.includes('olive')) return '#68705b';
    if (color.includes('evergreen') || color.includes('pine') || color.includes('green')) return '#176044';
    if (color.includes('gold') || color.includes('solar')) return '#d2a52b';
    if (color.includes('khaki') || color.includes('tan') || color.includes('tundra') || color.includes('sand') || color.includes('bone')) return '#c9bda6';
    if (color.includes('chrome') || color.includes('gunmetal') || color.includes('silver') || color.includes('grey') || color.includes('gray') || color.includes('carbon') || color.includes('stealth')) return '#aeb2b5';
    if (color.includes('white')) return '#f4f4f4';
    return '#111';
  };
  const paintSwatches = (layout) => {
    qsa('[data-theme-color-swatch]', layout).forEach((swatch) => {
      const name = swatch.dataset.themeColorChip || '';
      swatch.style.background = fallbackSwatch(name);
    });
  };
  qsa('[data-product-card]').forEach(paintSwatches);
  window.SkeezyTheme = { paintSwatches };
  if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('pointerover', event => {
      const card = event.target.closest('.product-card-media');
      const image = card && card.querySelector('[data-hover-src]');
      if (!image) return;
      image.srcset = image.dataset.hoverSrcset;
      image.src = image.dataset.hoverSrc;
      image.removeAttribute('data-hover-src');
      image.removeAttribute('data-hover-srcset');
    }, { passive: true });
  }

  const cartForm = qs('[data-cart-update-form]') || qsa('.cart-page form[action]').find((form) => new URL(form.action, window.location.href).pathname.replace(/\/$/, '') === `${routeRoot}cart`.replace(/\/$/, ''));
  if (cartForm) {
    let updateTimer;
    const submitCart = () => {
      clearTimeout(updateTimer);
      const updateButton = cartForm.querySelector('[name="update"]');
      if (cartForm.requestSubmit) { if (updateButton) { cartForm.requestSubmit(updateButton); } else { cartForm.requestSubmit(); } } else { cartForm.submit(); }
    };
    cartForm.querySelectorAll('input[name^="updates["]').forEach((input) => input.addEventListener('change', () => {
      clearTimeout(updateTimer);
      if (input.validity.valid) updateTimer = setTimeout(submitCart, 250);
    }));
    cartForm.addEventListener('submit', () => clearTimeout(updateTimer));
  }

  const setExpanded = (button, value) => button && button.setAttribute('aria-expanded', String(value));
  const menu = qs('#MobileMenu');
  const search = qs('[data-search-panel]');
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const visibleFocusables = (scope) => qsa(focusableSelector, scope).filter((element) => {
    if (element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
    let current = element;
    while (current && current !== scope.parentElement) {
      const style = getComputedStyle(current);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      current = current.parentElement;
    }
    return true;
  }).sort((first, second) => first.compareDocumentPosition(second) & Node.DOCUMENT_POSITION_PRECEDING ? 1 : -1);
  let menuTrigger;
  let searchTrigger;
  let previousOverflow = '';
  const menuBackground = new Map();
  const closeSearch = ({ restoreFocus = true } = {}) => {
    if (!search || search.hidden) return;
    const hadFocus = search.contains(document.activeElement);
    search.hidden = true;
    qsa('[data-search-toggle]').forEach((button) => setExpanded(button, false));
    if (restoreFocus && hadFocus && searchTrigger) searchTrigger.focus({ preventScroll: true });
  };
  const closeMenu = ({ restoreFocus = true } = {}) => {
    if (!menu || !root.classList.contains('menu-open')) return;
    root.classList.remove('menu-open');
    menu.hidden = true;
    menu.setAttribute('aria-hidden', 'true');
    qsa('[data-menu-toggle]').forEach((button) => setExpanded(button, false));
    document.body.style.overflow = previousOverflow;
    menuBackground.forEach((wasInert, element) => { element.inert = wasInert; });
    menuBackground.clear();
    if (restoreFocus && menuTrigger) menuTrigger.focus({ preventScroll: true });
  };
  window.SkeezyOverlays = { closeAll: (options) => { closeMenu(options); closeSearch(options); } };
  qsa('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!menu) return;
      if (root.classList.contains('menu-open')) { closeMenu(); return; }
      closeSearch({ restoreFocus: false });
      window.SkeezyCart?.close?.({ restoreFocus: false });
      window.SkeezyOffer?.hide?.({ restoreFocus: false });
      menuTrigger = button;
      previousOverflow = document.body.style.overflow;
      root.classList.add('menu-open');
      menu.hidden = false;
      menu.setAttribute('aria-hidden', 'false');
      qsa('[data-menu-toggle]').forEach((toggle) => setExpanded(toggle, true));
      document.body.style.overflow = 'hidden';
      let current = menu;
      while (current && current !== document.body) {
        [...current.parentElement.children].forEach((sibling) => {
          if (sibling === current) return;
          menuBackground.set(sibling, sibling.inert);
          sibling.inert = true;
        });
        current = current.parentElement;
      }
      (qs('[data-menu-close]', menu) || menu).focus({ preventScroll: true });
    });
  });
  qsa('[data-menu-close]').forEach((button) => button.addEventListener('click', () => closeMenu()));
  qsa('[data-search-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!search) return;
      if (!search.hidden) { closeSearch(); return; }
      closeMenu({ restoreFocus: false });
      window.SkeezyCart?.close?.({ restoreFocus: false });
      window.SkeezyOffer?.hide?.({ restoreFocus: false });
      searchTrigger = button;
      search.hidden = false;
      qsa('[data-search-toggle]').forEach((toggle) => setExpanded(toggle, true));
      qs('input[type="search"]', search)?.focus({ preventScroll: true });
    });
  });
  qsa('[data-search-close]').forEach((button) => button.addEventListener('click', () => closeSearch()));
  document.addEventListener('pointerdown', (event) => {
    if (search && !search.hidden && !search.contains(event.target) && !event.target.closest('[data-search-toggle]')) closeSearch({ restoreFocus: false });
  });
  document.addEventListener('keydown', (event) => {
    if (menu && root.classList.contains('menu-open')) {
      if (event.key === 'Escape') { event.preventDefault(); closeMenu(); return; }
      if (event.key !== 'Tab') return;
      const focusables = visibleFocusables(menu);
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (!first) { event.preventDefault(); menu.focus(); return; }
      if (event.shiftKey && (document.activeElement === first || !menu.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !menu.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    } else if (event.key === 'Escape' && search && !search.hidden) { event.preventDefault(); closeSearch(); }
  });
  matchMedia('(min-width: 821px)').addEventListener('change', (event) => { if (event.matches) closeMenu({ restoreFocus: false }); });
  addEventListener('pageshow', (event) => { if (event.persisted) window.SkeezyOverlays.closeAll({ restoreFocus: false }); });

  const header = qs('[data-site-header]');
  let headerState;
  const onScroll = () => {
    const next = window.scrollY > 18;
    if (header && next !== headerState) { header.classList.toggle('is-scrolled', next); headerState = next; }
  };
  onScroll();
  addEventListener('scroll', onScroll, { passive: true });

  qsa('[data-quantity]').forEach((control) => {
    const input = qs('input', control);
    if (!input) return;
    qsa('button', control).forEach((button) => {
      button.addEventListener('click', () => {
        if (input.disabled) return;
        const amount = Number(button.dataset.quantityChange || 0);
        const min = Number(input.min || 1);
        const max = input.max === '' ? Infinity : Number(input.max);
        const step = Number(input.step) > 0 ? Number(input.step) : 1;
        const current = Number.isFinite(input.valueAsNumber) ? input.valueAsNumber : min;
        const normalized = min + Math.round((current - min) / step) * step;
        const next = Number(Math.min(max, Math.max(min, normalized + amount * step)).toFixed(10));
        if (next === current && input.value !== '') return;
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  qsa('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  });
  let submittedForm;
  try { submittedForm = document.getElementById(decodeURIComponent(window.location.hash.slice(1))); } catch (error) { submittedForm = null; }
  const formStatuses = qsa('main [data-form-status]');
  const submittedStatus = submittedForm?.tagName === 'FORM' ? qs('[data-form-status]', submittedForm) : formStatuses.length === 1 ? formStatuses[0] : null;
  submittedStatus?.focus({ preventScroll: true });
})();

(() => {
  document.querySelectorAll('[data-cookie-preferences]').forEach(link => {
    link.addEventListener('click', event => {
      const banner = window.privacyBanner;
      if (banner && typeof banner.showPreferences === 'function') {
        event.preventDefault();
        banner.showPreferences();
      }
    });
  });
})();
